import React, { useState } from "react";

export default function PostList({ posts, onOpenCreateModal }) {
  const [activePage, setActivePage] = useState(1);
  const [filterPinnedOnly, setFilterPinnedOnly] = useState(false);
  const [openCommentId, setOpenCommentId] = useState(null);
  const [commentInput, setCommentInput] = useState({});
  const [postsState, setPostsState] = useState(posts);

  const handleAddComment = (postId) => {
    const text = commentInput[postId];
    if (!text || !text.trim()) return;

    setPostsState((prev) =>
      prev.map((p) => {
        if (p.id === postId) {
          return {
            ...p,
            comments: [
              ...(p.comments || []),
              {
                id: Date.now(),
                user: "Kế toán viên",
                text: text.trim(),
                time: "Vừa xong",
              },
            ],
          };
        }
        return p;
      })
    );

    setCommentInput({ ...commentInput, [postId]: "" });
  };

  const displayedPosts = filterPinnedOnly
    ? postsState.filter((p) => p.isPinned)
    : postsState;

  return (
    <div className="space-y-4">
      {/* Upper header line */}
      <div className="flex items-center justify-between gap-3 bg-white p-3.5 px-5 rounded-xl border border-gray-200/80 shadow-xs">
        <div className="flex items-center gap-2">
          <h2 className="text-base font-bold text-gray-800">Bài viết trong hệ thống</h2>
          <span className="inline-flex items-center justify-center bg-gray-100 text-gray-700 text-xs font-semibold px-2.5 py-0.5 rounded-full border border-gray-200">
            {postsState.length}
          </span>
        </div>

        <button
          onClick={onOpenCreateModal}
          className="inline-flex items-center gap-1.5 bg-blue-600 hover:bg-blue-700 text-white font-semibold text-xs md:text-sm px-4 py-2 rounded-lg shadow-xs transition-colors cursor-pointer"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M12 4v16m8-8H4" />
          </svg>
          Đăng bài
        </button>
      </div>

      {/* Sub-header line (filter & ghim options) */}
      <div className="flex flex-wrap items-center justify-between gap-3 bg-blue-50/50 p-3 px-4 rounded-xl border border-blue-100 text-xs text-gray-700">
        <div className="flex items-center gap-1.5 font-semibold text-blue-900">
          <span className="text-amber-500 text-sm">⚡</span>
          Tin tức cập nhật mới nhất từ hệ thống
        </div>

        <div className="flex items-center gap-2 md:gap-4">
          <button
            onClick={() => setFilterPinnedOnly(!filterPinnedOnly)}
            className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-md transition-colors ${
              filterPinnedOnly
                ? "bg-blue-600 text-white font-semibold shadow-xs"
                : "hover:bg-blue-100 text-blue-700 font-medium"
            }`}
          >
            📌 Nội dung đã ghim
            <span className="bg-white/20 text-current px-1.5 py-0.2 rounded-full text-[10px] font-bold">
              2
            </span>
          </button>

          <div className="flex items-center border border-gray-200 rounded-md bg-white overflow-hidden shadow-2xs">
            <button className="px-2 py-1 hover:bg-gray-100 border-r border-gray-200 text-gray-600">
              &lt;
            </button>
            <button className="px-2 py-1 hover:bg-gray-100 text-gray-600">
              &gt;
            </button>
          </div>

          <button className="inline-flex items-center gap-1 border border-gray-200 bg-white hover:bg-gray-50 px-2.5 py-1 rounded-md font-medium text-gray-700 shadow-2xs">
            <svg className="w-3.5 h-3.5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
            </svg>
            Bộ lọc
          </button>
        </div>
      </div>

      {/* List of Posts */}
      <div className="space-y-4">
        {displayedPosts.map((post) => {
          const isCommentOpen = openCommentId === post.id;
          return (
            <div
              key={post.id}
              className="bg-white rounded-xl shadow-sm border border-gray-200/80 overflow-hidden"
            >
              {/* Post Header */}
              <div className="p-4 md:p-5 flex items-start justify-between border-b border-gray-50">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-blue-600 text-white font-black flex items-center justify-center text-xs shadow-xs tracking-wider">
                    {post.author.slice(0, 5)}
                  </div>
                  <div>
                    <div className="flex items-center gap-2">
                      <span className="font-bold text-gray-900 text-sm">{post.author}</span>
                      {post.isNew && (
                        <span className="bg-red-600 text-white text-[10px] font-black px-1.5 py-0.2 rounded-sm tracking-wider uppercase shadow-2xs">
                          NEW
                        </span>
                      )}
                      {post.isPinned && (
                        <span className="text-sm" title="Bài viết đã ghim">
                          📌
                        </span>
                      )}
                    </div>
                    <span className="text-xs text-gray-400 mt-0.5 block font-medium">{post.date}</span>
                  </div>
                </div>

                <button className="text-gray-400 hover:text-gray-600 p-1 rounded-lg">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M6 10a2 2 0 11-4 0 2 2 0 014 0zM12 10a2 2 0 11-4 0 2 2 0 014 0zM16 12a2 2 0 100-4 2 2 0 000 4z" />
                  </svg>
                </button>
              </div>

              {/* Post Body Content */}
              <div className="p-4 md:p-5 space-y-3">
                <h3 className="text-base md:text-lg font-bold text-gray-900 leading-snug">
                  {post.title}
                </h3>

                <ul className="space-y-1.5 text-sm text-gray-700 leading-relaxed font-normal">
                  {post.bullets.map((bullet, idx) => (
                    <li key={idx} className="flex items-start gap-2">
                      <span className="text-gray-400 font-bold">•</span>
                      <span>{bullet.replace(/^•\s*/, "")}</span>
                    </li>
                  ))}
                </ul>

                {/* Mock Screenshot Gallery Attachments */}
                <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-3 pt-2">
                  {/* Mock Screenshot 1: Table view */}
                  <div className="rounded-lg border border-gray-200 overflow-hidden shadow-xs bg-gray-50 text-[11px]">
                    <div className="bg-gray-100 px-3 py-1.5 border-b border-gray-200 flex items-center justify-between text-gray-600 font-semibold">
                      <span>DANH SÁCH PHIẾU CHỜ DUYỆT</span>
                      <span className="text-[10px] bg-blue-100 text-blue-700 px-1.5 py-0.2 rounded">Tất cả phiếu</span>
                    </div>
                    <div className="p-2 space-y-1 bg-white">
                      {[
                        { code: "DNTT-ICOOL-21092026092511", type: "Chờ xét duyệt", name: "CÙI CÀ LY", store: "ICOOL Thành Thái" },
                        { code: "DNTT-ICOOL-21092026092505", type: "Chờ xét duyệt", name: "NGUYỄN LÊ MÂN", store: "ICOOL Trần Bình Trọng" },
                        { code: "DNTT-ICOOL-21092026092501", type: "Chờ xét duyệt", name: "NGUYỄN LÊ MÂN", store: "ICOOL Trần Bình Trọng" },
                      ].map((item, idx) => (
                        <div key={idx} className="flex items-center justify-between p-1.5 bg-gray-50/70 rounded border border-gray-100 text-[10px]">
                          <span className="bg-amber-100 text-amber-800 px-1 rounded font-medium">{item.type}</span>
                          <span className="font-bold text-blue-600">{item.code}</span>
                          <span className="text-gray-500 truncate max-w-[100px]">{item.store}</span>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Mock Screenshot 2: Modal Approval view */}
                  <div className="rounded-lg border border-gray-200 overflow-hidden shadow-xs bg-gray-50 text-[11px]">
                    <div className="bg-gray-100 px-3 py-1.5 border-b border-gray-200 flex items-center justify-between text-gray-600 font-semibold">
                      <span>CHI TIẾT PHIẾU #DNTT-21092026092511</span>
                      <span className="bg-emerald-100 text-emerald-700 px-1.5 py-0.2 rounded text-[10px]">Duyệt nhanh</span>
                    </div>
                    <div className="p-3 bg-white space-y-2">
                      <div className="flex justify-between items-center text-gray-700 border-b pb-1">
                        <span>Số tiền:</span>
                        <span className="font-bold text-blue-700 text-xs">600.000 đ</span>
                      </div>
                      <div className="flex justify-between items-center text-gray-700 border-b pb-1">
                        <span>Người tạo:</span>
                        <span className="font-semibold">Lê Lương Vũ Phúc Lộc</span>
                      </div>
                      <div className="flex gap-2 pt-1 justify-end">
                        <button className="bg-red-500 text-white px-2 py-0.5 rounded text-[10px] font-bold">✕ Từ chối</button>
                        <button className="bg-emerald-600 text-white px-2 py-0.5 rounded text-[10px] font-bold">✓ Duyệt</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Post Footer / Comment Toggle */}
              <div className="px-4 py-3 bg-gray-50/70 border-t border-gray-100 flex items-center justify-start">
                <button
                  onClick={() => setOpenCommentId(isCommentOpen ? null : post.id)}
                  className="inline-flex items-center gap-1.5 text-xs font-semibold text-gray-600 hover:text-blue-600 transition-colors"
                >
                  <svg className="w-4 h-4 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 10h.01M12 10h.01M16 10h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                  </svg>
                  Bình luận ({post.comments?.length || 0})
                </button>
              </div>

              {/* Comments Drawer / Input Box */}
              {isCommentOpen && (
                <div className="p-4 bg-gray-50 border-t border-gray-200/60 space-y-3">
                  {post.comments && post.comments.length > 0 && (
                    <div className="space-y-2">
                      {post.comments.map((c) => (
                        <div key={c.id} className="bg-white p-2.5 rounded-lg border border-gray-200/80 text-xs">
                          <div className="flex items-center justify-between mb-1">
                            <span className="font-bold text-gray-800">{c.user}</span>
                            <span className="text-[10px] text-gray-400">{c.time}</span>
                          </div>
                          <p className="text-gray-700">{c.text}</p>
                        </div>
                      ))}
                    </div>
                  )}

                  <div className="flex items-center gap-2">
                    <input
                      type="text"
                      placeholder="Viết bình luận..."
                      value={commentInput[post.id] || ""}
                      onChange={(e) => setCommentInput({ ...commentInput, [post.id]: e.target.value })}
                      onKeyDown={(e) => e.key === "Enter" && handleAddComment(post.id)}
                      className="flex-1 px-3 py-1.5 text-xs rounded-lg border border-gray-300 focus:outline-none focus:border-blue-500 bg-white"
                    />
                    <button
                      onClick={() => handleAddComment(post.id)}
                      className="bg-blue-600 text-white text-xs font-semibold px-3 py-1.5 rounded-lg hover:bg-blue-700 transition-colors"
                    >
                      Gửi
                    </button>
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>

      {/* Pagination Bar */}
      <div className="flex items-center justify-center gap-1.5 pt-4 text-xs font-semibold text-gray-600">
        <button className="w-8 h-8 rounded-lg hover:bg-gray-100 flex items-center justify-center text-gray-400">
          &laquo;
        </button>
        <button className="w-8 h-8 rounded-lg hover:bg-gray-100 flex items-center justify-center text-gray-400">
          &lt;
        </button>
        {[1, 2, 3, 4].map((page) => (
          <button
            key={page}
            onClick={() => setActivePage(page)}
            className={`w-8 h-8 rounded-lg flex items-center justify-center transition-colors ${
              activePage === page
                ? "bg-blue-600 text-white shadow-xs"
                : "bg-white border border-gray-200 hover:bg-gray-50 text-gray-700"
            }`}
          >
            {page}
          </button>
        ))}
        <span className="px-1 text-gray-400">...</span>
        <button className="w-8 h-8 rounded-lg hover:bg-gray-100 flex items-center justify-center text-gray-600">
          &gt;
        </button>
        <button className="w-8 h-8 rounded-lg hover:bg-gray-100 flex items-center justify-center text-gray-600">
          &raquo;
        </button>
      </div>
    </div>
  );
}
